import React from 'react';

import { HandsUpIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type HandsupEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
    handsup_score?: number;
  };
};

export function HandsupDetails({ event }: { event: HandsupEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.handsup_score);
  const detection = event.event.overview?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionType="bbox"
      event={event}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<HandsUpIcon />}
          kind="neutral"
          size="large"
          value={`${t('videoAnalytics:handsupAnalyticDetails.workspace.tag.label')} ${score}%`}
        />
      )}
      title={t('videoAnalytics:handsupAnalyticDetails.workspace.title')}
    />
  );
}
